import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Users, Building2 } from 'lucide-react';
import { stats } from '../data/mock';

const HeroSection = ({ onJoinWaitlist, onForBusinesses, onForStaff }) => {
  return (
    <section
      className="min-h-screen flex items-center justify-center relative overflow-hidden pt-20"
      style={{ background: 'var(--bg-hero)' }}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* Badge */}
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full border mb-8"
              style={{ background: 'rgba(255,255,255,0.08)', borderColor: 'rgba(255,255,255,0.15)' }}
            >
              <span className="w-2 h-2 rounded-full bg-[#8FEC78] animate-pulse" />
              <span className="text-sm font-medium" style={{ color: 'rgba(255,255,255,0.8)' }}>
                Launching Soon in South Africa
              </span>
            </div>

            {/* Main Headline */}
            <h1 className="heading-1 mb-6" style={{ color: '#FFFFFF' }}>
              Staff when you
              <br />
              <span className="relative inline-block">
                need them
                <svg
                  className="absolute -bottom-2 left-0 w-full"
                  height="12"
                  viewBox="0 0 200 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 8C50 4 150 4 198 8"
                    stroke="#8FEC78"
                    strokeWidth="4"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            </h1>

            {/* Subheadline */}
            <p className="body-large max-w-2xl mx-auto mb-10" style={{ color: 'rgba(255,255,255,0.65)' }}>
              Hire verified hospitality staff on demand — even for one hour.
              <br className="hidden sm:block" />
              Perfect for restaurants, hotels, cafés, and events.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <button onClick={onJoinWaitlist} className="btn-primary text-lg px-8 py-4 gap-2">
                Join the Waitlist
                <ArrowRight size={20} />
              </button>
              <div className="flex items-center gap-3">
                <button onClick={onForBusinesses} className="btn-secondary btn-secondary-light gap-2">
                  <Building2 size={18} />
                  For Businesses
                </button>
                <button onClick={onForStaff} className="btn-secondary btn-secondary-light gap-2">
                  <Users size={18} />
                  For Staff
                </button>
              </div>
            </div>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-2xl mx-auto"
          >
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="heading-2 mb-1" style={{ color: '#8FEC78' }}>
                  {stat.value}
                </div>
                <div className="text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
